import { blueGrey } from "@mui/material/colors";

import { useThemeMode } from "./useThemeMode";

/**
 * Commonly used background color for landing pages, dashboards, etc.
 * This is a light grey for light mode and a dark grey for dark mode.
 */
export function useThemeGreyBackgroundColor() {
  const { themeMode } = useThemeMode();

  return blueGrey[themeMode === "light" ? 50 : 900];
}
